module.exports = __webpack_public_path__ + "static/img/a091.e7a3e5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a091.jpg
// module id = CxmZ
// module chunks = 0